export default __webpack_public_path__ + "static/media/main.a02b362c.jpg";